import { AddressStreetType } from "@1games-ru/region-shared/dist/enums/address/address";
import { useCallback, useEffect, useState } from "react";
import CreateEntityMpProvider from "@/core/data-provider/data-mp/create-entity/create-entity-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export type AddressStreet = {
  id: number;
  name: string;
  type: AddressStreetType;
};

export default function useAddressStreets() {
  const [isPending, setIsPending] = useState(false);
  const [data, setData] = useState<AddressStreet[] | null>(null);

  async function getAddressStreets() {
    setIsPending(true);

    const response = await CreateEntityMpProvider.getAddressStreets({
      streetIds: null,
      streetName: null,
      pointIds: null,
    });

    if (response instanceof RpcMpProviderFailedResponse) {
      setIsPending(false);
      console.error(response);
      throw new Error("getAddressStreets - CreateEntityMpProvider.getAddressStreets() error");
    }

    setIsPending(false);

    setData(
      response.data.map((street) => ({
        id: street.streetId,
        name: street.streetName,
        type: street.streetType,
      })),
    );
  }

  useEffect(() => {
    getAddressStreets();
  }, []);

  const refetch = useCallback(async () => {
    await getAddressStreets();
  }, []);

  return { data, isPending, refetch };
}
